import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Container, Nav } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";

import Header_Company from "../../Components/Header_Company";
import Company_Agent from "../../Components/CompanyDetails/Company_Agent";
import Company_Supervisor from "../../Components/CompanyDetails/Company_Supervisor";
import "./Company.css";

const Company_Team = () => {
  const [activeTab, setActiveTab] = useState("supervisor");

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("user");
    if (!storedUserData) {
      Swal.fire("Error", "Your session has expired. Please sign in again.", "error");
    }
  }, []);

  return (
    <div className="co-page">
      <Header_Company />

      <Container fluid="xl">
        <div className="co-hero">
          <h2>
            <i className="bi bi-people me-2" />
            Company Team
          </h2>
          <p>Manage supervisors and agents for your organization.</p>
        </div>

        <Nav variant="pills" className="co-step-nav gap-2 mb-3 flex-nowrap">
          <Nav.Item>
            <Nav.Link
              active={activeTab === "supervisor"}
              onClick={() => setActiveTab("supervisor")}
            >
              <i className="bi bi-person-badge me-1" />
              Supervisors
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              active={activeTab === "agent"}
              onClick={() => setActiveTab("agent")}
            >
              <i className="bi bi-person-vcard me-1" />
              Agents
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {activeTab === "supervisor" && <Company_Supervisor />}
        {activeTab === "agent" && <Company_Agent />}
      </Container>
    </div>
  );
};

export default Company_Team;
